package org.chiangmeng.qfast.database

import kotlin.Long
import kotlin.String

public data class LocalShopStateEntity(
  public val shop_id: String,
  public val last_ticket: Long,
  public val current_servings_json: String,
)
